import { render, staticRenderFns } from "./mediaIndex.vue?vue&type=template&id=5e56ac04&scoped=true"
import script from "./mediaIndex.vue?vue&type=script&lang=js"
export * from "./mediaIndex.vue?vue&type=script&lang=js"
import style0 from "./mediaIndex.vue?vue&type=style&index=0&id=5e56ac04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e56ac04",
  null
  
)

export default component.exports